function pasteValue(event) {
    const originalValue = event.target.value; // Get the value before paste
    const pastedValue = event.clipboardData.getData('Text').trim(); // Get and trim the pasted text

    const selectionStart = event.target.selectionStart;
    const selectionEnd = event.target.selectionEnd;

    // Check if the entire input is selected (Ctrl + A)
    const isSelectAll = selectionStart === 0 && selectionEnd === originalValue.length;

    if (isSelectAll) {
        // If the entire input is selected, replace the value with the pasted content
        event.target.value = pastedValue;
    } else {
        // If only part of the input is selected or nothing is selected, proceed as before
        const beforeCursor = originalValue.slice(0, selectionStart); // Part before the cursor
        const afterCursor = originalValue.slice(selectionEnd); // Part after the cursor

        // Create the new value by combining before, pasted, and after parts
        event.target.value = beforeCursor + pastedValue + afterCursor;

        // Update the cursor position (it will be right after the pasted text)
        event.target.selectionStart = event.target.selectionEnd = selectionStart + pastedValue.length;
    }
    return event;
}

module.exports = {
    pasteValue
}